import { StausButtonWrapper } from './styles';

export const StatusButton = (props) => {
  let { status } = props;
  return (
    <StausButtonWrapper status={status}>{status?.label}</StausButtonWrapper>
  );
};
